export default "__VITE_ASSET__a6cf9343__"